var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.26511 20.3063L9.40211 17.2L12.5391 20.3063L9.40211 23.4125L6.26511 20.3063ZM20.1828 12.7812L25.5731 18.1188L28.7101 15.0125L23.3198 9.67498L20.1828 6.56873L17.0458 9.67498L11.6554 14.9687L14.7924 18.075L20.1828 12.7812ZM27.8264 20.3063L30.9634 17.2L34.1004 20.3063L30.9634 23.4125L27.8264 20.3063ZM20.1828 27.8313L14.7924 22.5375L11.6554 25.6438L17.0458 30.9375L20.1828 34.0438L23.3198 30.9375L28.7101 25.6L25.5731 22.5375L20.1828 27.8313Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0458 20.3063L20.1828 17.2L23.3198 20.3063L20.1828 23.4125L17.0458 20.3063Z",
    fill: "#F0B90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 29,
    height: 29,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceIcon);
export default __webpack_public_path__ + "static/media/binance-icon.fb56ff00103311a57c6e5cd63d028c53.svg";
export { ForwardRef as ReactComponent };